module.exports = __webpack_public_path__ + "static/media/Settings.53ebd2af.svg";